/**
 * /dashboard/leave — Leave module hub, "My requests" view (SOP §1.2;
 * Phase 3b — 2026-06-01).
 *
 * The old Next.js page intercepted legacy `?tab=balance|approvals`
 * deep-links with a server-side redirect; in the Vite SPA every entry
 * point goes through the typed router so the legacy-tab redirect helper
 * is dropped. Anyone bookmarking the old query-string surface lands on
 * the My Requests view, which is the original default anyway.
 *
 * Body is `<LeaveRequestList mode="self">` + a top-right "Request leave"
 * CTA. PageHeader + Time & Leave strip come from the shared
 * TimeAndLeaveShell — same DRY pattern as Calendar / Approvals (Phase
 * 3a).
 *
 * Migration note: port of frontend/src/app/(dashboard)/dashboard/leave/page.tsx
 * (server component, legacy `?tab=` redirect dropped) +
 * frontend/src/components/leave/leave-requests-tab.tsx (CTA + list)
 * flattened into one client component since the redirect step is gone.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { CalendarPlus } from "lucide-react";
import { TimeAndLeaveShell } from "@/components/shared/time-and-leave-shell";
import { LeaveFeatureGate } from "@/components/leave/leave-feature-gate";
import { LeaveRequestList } from "@/components/leave/leave-request-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/leave/")({
  component: LeaveHubRoute,
});

function LeaveHubRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <TimeAndLeaveShell
      title="Leave"
      description="Your leave requests, balances and approvals."
      actions={
        <Button asChild className="gap-1.5">
          <Link to="/app/$tenantSlug/leave/new" params={{ tenantSlug }}>
            <CalendarPlus className="h-4 w-4" />
            Request leave
          </Link>
        </Button>
      }
    >
      <LeaveFeatureGate>
        <LeaveRequestList mode="self" />
      </LeaveFeatureGate>
    </TimeAndLeaveShell>
  );
}
